import { useSelector } from 'react-redux';

/**
 * 현재 로그인 유저가 특정 액션 권한을 가지고 있는지 확인하는 훅.
 * SUPERADMIN, MANAGER는 항상 true를 반환한다.
 * EMPLOYEE는 로그인 응답의 userMenus(Redux menu)에 해당 menuAuthCode가 있는지 확인한다.
 *
 * @param {string} menuAuthCode - 권한 코드 (예: 'MEMBER_SMS', 'MEMBER_TRANSFER')
 * @returns {boolean} 권한 보유 여부
 */
const useUserAuth = menuAuthCode => {
  const userRole = useSelector(state => state.user.user?.userRole);
  const menu = useSelector(state => state.menu.menu);

  if (userRole === 'ROLE_SUPERADMIN') return true;
  if (!menu || menu.length === 0) return false;

  return menu.some(m => m.menuAuthCode === menuAuthCode);
};

export default useUserAuth;
